/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Editor_Photo_UrlInputs */

const en_resume_editor_photo_url = /** @type {(inputs: Resume_Editor_Photo_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photo URL`)
};

const de_resume_editor_photo_url = /** @type {(inputs: Resume_Editor_Photo_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foto-URL`)
};

const fr_resume_editor_photo_url = /** @type {(inputs: Resume_Editor_Photo_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL de la photo`)
};

const es_resume_editor_photo_url = /** @type {(inputs: Resume_Editor_Photo_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL de foto`)
};

const it_resume_editor_photo_url = /** @type {(inputs: Resume_Editor_Photo_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL foto`)
};

const nl_resume_editor_photo_url = /** @type {(inputs: Resume_Editor_Photo_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foto-URL`)
};

const pl_resume_editor_photo_url = /** @type {(inputs: Resume_Editor_Photo_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL zdjecia`)
};

const fi_resume_editor_photo_url = /** @type {(inputs: Resume_Editor_Photo_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuvan URL`)
};

const da_resume_editor_photo_url = /** @type {(inputs: Resume_Editor_Photo_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foto-URL`)
};

const sv_resume_editor_photo_url = /** @type {(inputs: Resume_Editor_Photo_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foto-URL`)
};

/**
* | output |
* | --- |
* | "Photo URL" |
*
* @param {Resume_Editor_Photo_UrlInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resume_editor_photo_url = /** @type {((inputs?: Resume_Editor_Photo_UrlInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Editor_Photo_UrlInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resume_editor_photo_url(inputs)
	if (locale === "fr") return fr_resume_editor_photo_url(inputs)
	if (locale === "es") return es_resume_editor_photo_url(inputs)
	if (locale === "it") return it_resume_editor_photo_url(inputs)
	if (locale === "nl") return nl_resume_editor_photo_url(inputs)
	if (locale === "pl") return pl_resume_editor_photo_url(inputs)
	if (locale === "fi") return fi_resume_editor_photo_url(inputs)
	if (locale === "da") return da_resume_editor_photo_url(inputs)
	if (locale === "sv") return sv_resume_editor_photo_url(inputs)
	return en_resume_editor_photo_url(inputs)
});